(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-peek-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var instances = new WeakMap();

    function init(root) {
      if (!root || instances.has(root)) return;
      var track = root.querySelector('[data-oc-track]');
      var realSlides = track ? Array.from(track.querySelectorAll('[data-oc-slide]')) : [];
      if (!track || !realSlides.length) return;
      var count = realSlides.length;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var editor = Boolean(window.Shopify && window.Shopify.designMode);
      var interval = Math.max(2500, Number(root.dataset.delay) || 5500);
      var duration = reduced ? 0 : Math.max(0, Number(root.dataset.duration) || 800);
      var index = count > 1 ? 1 : 0;
      var items = realSlides.slice();
      var locked = false;
      var hovering = false;
      var hasFocus = false;
      var editorHold = false;
      var pointer = null;
      var suppressClick = false;
      var timer = null;
      var resizeObserver = null;
      var abort = new AbortController();
      var signal = abort.signal;
      var status = root.querySelector('[data-oc-status]');
      var dots = Array.from(root.querySelectorAll('[data-oc-dot]'));

      if (count > 1) {
        var lastClone = realSlides[count - 1].cloneNode(true);
        var firstClone = realSlides[0].cloneNode(true);
        [lastClone, firstClone].forEach(function (clone) {
          clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) {
            el.removeAttribute('data-shopify-editor-block');
          });
          clone.removeAttribute('data-shopify-editor-block');
          clone.setAttribute('data-oc-clone', 'true');
        });
        track.insertBefore(lastClone, track.firstChild);
        track.appendChild(firstClone);
        items = Array.from(track.querySelectorAll('[data-oc-slide]'));
      }

      function currentReal() {
        return count === 1 ? 0 : ((index - 1 + count) % count);
      }

      function position(animate) {
        var width = items[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var offset = root.getBoundingClientRect().width / 2 - width / 2 - index * (width + gap);
        track.style.transitionDuration = animate && duration ? duration + 'ms' : '0ms';
        track.classList.toggle('is-animated', Boolean(animate && duration));
        track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }

      function updateState(announce) {
        var current = currentReal();
        items.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.querySelectorAll('a,button,input,[tabindex]').forEach(function (el) {
            if (el.matches('a,button,input')) {
              if (active) el.removeAttribute('tabindex');
              else el.setAttribute('tabindex', '-1');
            }
          });
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-current', i === current);
          dot.setAttribute('aria-current', String(i === current));
        });
        if (announce && status) status.textContent = 'Diapositiva ' + (current + 1) + ' de ' + count;
      }

      function moveTo(target, announce) {
        if (count < 2 || locked || target === index) return;
        index = target;
        locked = duration > 0;
        updateState(announce);
        position(true);
        if (!locked) snapBoundary();
      }

      function snapBoundary() {
        if (count > 1 && (index === 0 || index === count + 1)) {
          index = index === 0 ? count : 1;
          position(false);
          updateState(false);
        }
        locked = false;
      }

      if (count > 1) {
        track.addEventListener('transitionend', function (event) {
          if (event.target !== track || event.propertyName !== 'transform') return;
          snapBoundary();
        }, {signal: signal});

        var prev = root.querySelector('[data-oc-prev]');
        var next = root.querySelector('[data-oc-next]');
        if (prev) prev.addEventListener('click', function () { moveTo(index - 1, true); }, {signal: signal});
        if (next) next.addEventListener('click', function () { moveTo(index + 1, true); }, {signal: signal});
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () { moveTo(Number(dot.dataset.ocDot) + 1, true); }, {signal: signal});
        });
        track.addEventListener('click', function (event) {
          if (suppressClick) {
            event.preventDefault();
            suppressClick = false;
            return;
          }
          if (event.target.closest('a')) return;
          var slide = event.target.closest('[data-oc-slide]');
          if (!slide || locked) return;
          var target = items.indexOf(slide);
          if (target === index - 1 || target === index + 1) moveTo(target, true);
        }, {signal: signal});

        var viewport = root.querySelector('[data-oc-viewport]');
        viewport.addEventListener('pointerdown', function (event) {
          if (event.button !== 0 || event.target.closest('a,button')) return;
          pointer = { x: event.clientX, y: event.clientY };
        }, {signal: signal});
        viewport.addEventListener('pointerup', function (event) {
          if (!pointer) return;
          var dx = event.clientX - pointer.x;
          var dy = event.clientY - pointer.y;
          pointer = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25) {
            suppressClick = true;
            moveTo(index + (dx < 0 ? 1 : -1), true);
            window.setTimeout(function () { suppressClick = false; }, 250);
          }
        }, {signal: signal});
        viewport.addEventListener('pointercancel', function () { pointer = null; }, {signal: signal});
        viewport.addEventListener('keydown', function (event) {
          if (event.target.closest('a,button,input')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            moveTo(index + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        }, {signal: signal});
      }

      root.addEventListener('pointerenter', function () { if (root.dataset.pauseHover === 'true') hovering = true; }, {signal: signal});
      root.addEventListener('pointerleave', function () { hovering = false; }, {signal: signal});
      root.addEventListener('focusin', function () { hasFocus = true; }, {signal: signal});
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) hasFocus = false;
      }, {signal: signal});

      var autoEnabled = count > 1 && !reduced && !editor && root.dataset.autoplay === 'true';
      if (autoEnabled) timer = window.setInterval(function () {
        if (!hovering && !hasFocus && !editorHold && !document.hidden && !locked) moveTo(index + 1, false);
      }, interval);

      document.addEventListener('shopify:block:select', function (event) {
        var slide = event.target.closest('[data-oc-block]');
        if (!slide || !root.contains(slide)) return;
        editorHold = true;
        var target = realSlides.indexOf(slide);
        if (target >= 0) {
          locked = false;
          index = count > 1 ? target + 1 : 0;
          position(false);
          updateState(false);
        }
      }, {signal: signal});
      document.addEventListener('shopify:block:deselect', function (event) {
        if (root.contains(event.target)) editorHold = false;
      }, {signal: signal});
      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target.contains(root)) destroy();
      }, {signal: signal});

      function resize() {
        locked = false;
        position(false);
      }
      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(resize);
        resizeObserver.observe(root);
      } else window.addEventListener('resize', resize, {signal: signal});

      function destroy() {
        if (timer) clearInterval(timer);
        if (resizeObserver) resizeObserver.disconnect();
        abort.abort();
        instances.delete(root);
      }
      instances.set(root, { destroy: destroy });
      position(false);
      updateState(false);
    }

    function scan(scope) {
      if (scope.matches && scope.matches('[data-oc-peek]')) init(scope);
      if (scope.querySelectorAll) scope.querySelectorAll('[data-oc-peek]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
    else scan(document);
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
